var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "9.042mm",
    height: "9.0438mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 143.38 143.41",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1993224671392"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#999999",
    fillRule: "nonzero",
    d: "M71.71 137.03c-0.01,-0 -0.03,-0 -0.04,-0 -36.1,0 -65.37,-29.27 -65.37,-65.37 0,-36.1 29.27,-65.37 65.37,-65.37 36.09,0 65.37,29.27 65.37,65.37 0,0.01 0,0.03 0,0.04 -0.06,36.05 -29.28,65.27 -65.32,65.33l-0 0zm0 -127.13c-34.13,0 -61.8,27.67 -61.8,61.8 0,34.13 27.67,61.8 61.8,61.8 34.13,0 61.8,-27.67 61.8,-61.8 -0.02,-34.12 -27.68,-61.78 -61.8,-61.8l-0 0z"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 -0.000167407 2.4917)",
    width: 3.52,
    height: 199.25
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillRule: "nonzero",
    transform: "matrix(0.707107 -0.707107 0.707107 0.707107 -0.000167407 140.922)",
    width: 199.25,
    height: 3.52
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc23);
export default __webpack_public_path__ + "static/media/ic_2_3.94217e5591a32797645250d3dbb920b1.svg";
export { ForwardRef as ReactComponent };